/* Square owns storage, counts and actions. This only adapts its UI to Horizon. */
(() => {
  if (document.documentElement.hasAttribute('data-kinahh-square-ready')) return;
  document.documentElement.setAttribute('data-kinahh-square-ready', '');
  const messages = document.querySelector('#KinahhWishlistMessages');
  if (!messages) return;
  const copy = messages.dataset;
  const controls = '.Vtl-WishlistButton__AddToWishlist,.Vtl-WishlistButton__WishlistIconButton,.Vtl-WishlistProduct__CloseButton';
  const relevant = controls + ',.Vtl-WishlistHeaderWrapper,.Vtl-WishlistHeader';
  function enhance(element) {
    if (element.matches('.Vtl-WishlistHeader')) {
      element.setAttribute('aria-label', copy.view);
      return;
    }
    if (element.matches('.Vtl-WishlistHeaderWrapper')) {
      const header = document.querySelector('header-actions');
      if (header && element.parentElement !== header) header.prepend(element);
      const link = element.querySelector('a');
      if (link) link.setAttribute('aria-label', copy.view);
      return;
    }
    if (element.matches('button,a') || element.hasAttribute('data-kinahh-wishlist-control')) return;
    element.setAttribute('role', 'button');
    element.setAttribute('tabindex', '0');
    element.setAttribute('data-kinahh-wishlist-control', '');
    if (element.matches('.Vtl-WishlistProduct__CloseButton')) {
      const title = element.closest('.Vtl-WishlistProduct')?.querySelector('.Vtl-WishlistProduct__Title')?.textContent.trim();
      element.setAttribute('aria-label', copy.removeNamed.replace('__TITLE__', title || ''));
    } else if (element.matches('.Vtl-WishlistButton__WishlistIconButton')) {
      element.setAttribute('aria-label', copy.toggle);
    }
  }
  function scan(root) {
    if (!(root instanceof Element)) return;
    if (root.matches(relevant)) enhance(root);
    root.querySelectorAll(relevant).forEach(enhance);
  }
  scan(document.body);
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) scan(node);
  }).observe(document.body, {childList:true, subtree:true});
  document.addEventListener('keydown', event => {
    const control = event.target.closest?.('[data-kinahh-wishlist-control]');
    if (control && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      control.click();
    }
  });
  const saves = '.Vtl-WishlistButton__AddToWishlist,.Vtl-WishlistButton__WishlistIconButton';
  const pending = new Map();
  let queuedLink = '';
  let hideNotice;
  const notice = document.createElement('div');
  notice.className = 'kinahh-wishlist-notice';
  notice.hidden = true;
  const noticeText = document.createElement('span');
  noticeText.setAttribute('role', 'status');
  noticeText.setAttribute('aria-live', 'polite');
  const view = document.createElement('a');
  view.href = copy.wishlistUrl;
  view.textContent = copy.view;
  notice.append(noticeText, view);
  document.body.append(notice);
  function announce(text, persistent = false) {
    clearTimeout(hideNotice);
    noticeText.textContent = text;
    notice.hidden = false;
    if (!persistent) hideNotice = setTimeout(() => { notice.hidden = true; }, 4500);
  }
  function productKey(control) {
    const wrapper = control.closest('[class*="Vtl-WishlistIcon__Wrapper--Id-"],[class*="Vtl-WishlistIcon__ProductPageWrapper--Id-"]') || document.querySelector('[class*="Vtl-WishlistIcon__ProductPageWrapper--Id-"]');
    return wrapper?.className.match(/--Id-(\d+)/)?.[1] || 'product-page';
  }
  function saved(control) {
    const label = control.getAttribute('title') || control.textContent.trim();
    if (label === copy.saved) return true;
    if (label === copy.save) return false;
    return null;
  }
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a');
    if (link && new URL(link.href).pathname === copy.wishlistUrl && pending.size) {
      event.preventDefault();
      queuedLink = link.href;
      announce(copy.saving, true);
      return;
    }
    const control = event.target.closest?.(saves);
    if (!control) return;
    const key = productKey(control);
    if (pending.has(key)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    const before = saved(control);
    if (before === null) return;
    control.setAttribute('aria-busy', 'true');
    announce(before ? copy.removing : copy.saving, true);
    let timeout;
    const root = control.closest('.Vtl-WishlistButtonWrapper,.Vtl-WishlistIcon__Wrapper,.Vtl-WishlistIcon__ProductPageWrapper')?.parentElement || control.parentElement;
    function finish(success) {
      observer.disconnect();
      clearTimeout(timeout);
      pending.delete(key);
      document.querySelectorAll(saves).forEach(button => {
        if (productKey(button) === key) button.removeAttribute('aria-busy');
      });
      if (!success) queuedLink = '';
      announce(pending.size ? copy.saving : success ? (before ? copy.removed : copy.saved) : copy.unconfirmed, !success || pending.size > 0);
      if (!pending.size && queuedLink) window.location.assign(queuedLink);
    }
    function check() {
      const updated = [...root.querySelectorAll(saves)].find(button => productKey(button) === key && saved(button) === !before);
      if (updated) finish(true);
    }
    const observer = new MutationObserver(check);
    pending.set(key, true);
    observer.observe(root, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['title']});
    timeout = setTimeout(() => finish(false), 12000);
  }, true);
  if (messages.content.childElementCount) {
    const main = document.querySelector('main');
    if (main) {
      main.prepend(messages.content.cloneNode(true));
      const loading = main.querySelector('[data-wishlist-loading]');
      const account = main.querySelector('.kinahh-wishlist-account');
      const retry = loading.querySelector('[data-wishlist-retry]');
      retry.addEventListener('click', () => window.location.reload());
      const slow = setTimeout(() => {
        loading.querySelector('[role="status"]').textContent = copy.slow;
        retry.hidden = false;
      }, 12000);
      const loaded = () => {
        const page = main.querySelector('.Vtl-WishlistPage');
        if (!page?.textContent.trim()) return;
        clearTimeout(slow);
        loading.hidden = true;
        if (account) page.after(account);
        ready.disconnect();
      };
      const ready = new MutationObserver(loaded);
      ready.observe(main, {childList:true, subtree:true});
      loaded();
    }
  }

})();
